export const CHAT_ROLES = {
    USER: 'user',
    ASSISTANT: 'assistant',
};
